import { useQuery } from "@tanstack/react-query";
import { useAppState } from "Context/StateContext";
import { Company } from "Models/company";
import UserCompanyService from "Services/user.company.service";
import { CompanyProfile, Status } from "Util/enums";

export const useAgentSelectCompanyActions = () => {
  const { currentUser } = useAppState();

  const getMovingCompaniesWithAccess = () =>
    useQuery({
      queryKey: ["user.company.list", currentUser?.id, currentUser?.companyId],
      queryFn: () =>
        UserCompanyService.getAll({
          userId: currentUser?.id,
          status: Status.ACTIVE,
          include: JSON.stringify([
            {
              required: true,
              association: "company",
              attributes: ["id", "name"],
              include: [
                { association: "icon" },
                {
                  association: "profile",
                  attributes: ["id", "name"],
                  where: {
                    initials: [CompanyProfile.MV],
                  },
                },
              ],
              where: { status: Status.ACTIVE },
            },
          ]),
          sortBy: JSON.stringify([["company", "name", "asc"]]),
        }).then(({ data }) => data.map((userCompany) => userCompany.company)),
      initialData() {
        return [] as Company[];
      },
      refetchOnWindowFocus: false,
      enabled: !!currentUser?.id,
      onSuccess: (response) => {
        return response;
      },
    });

  return {
    getMovingCompaniesWithAccess,
  }
};
